import React, { useEffect } from 'react';

import * as echarts from 'echarts';

export const BarChart = ({ id, width, height }) => {
  useEffect(() => {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom, null, {
      width,
      height,
    });
    var option;

    option = {
      title : {
        text : null,
      },
      tooltip : {
        trigger     : 'axis',
        axisPointer : {
          type : 'shadow',
        },
      },
      legend : {
        show : false,
      },
      axisPointer : {
        show : false,
      },
      grid : {
        top          : 15,
        left         : 0,
        right        : 0,
        bottom       : -15,
        containLabel : true,
      },
      xAxis : {
        type        : 'value',
        boundaryGap : [0, 0.11],
        show        : false,
      },
      yAxis : {
        type : 'category',
        data : [
          '100 miles',
          '60-99 miles',
          '30-59 miles',
          '10-29 miles',
          '<10 miles',
        ],
        axisLabel : {
          inside        : true,
          margin        : 0,
          verticalAlign : 'bottom',
          lineHeight    : 37,
          fontSize      : 14,
          color         : '#434343',
          fontFamily    : 'Montserrat',
        },
        axisTick : {
          show : false,
        },
        axisLine : {
          show : false,
        },
      },
      series : [
        {
          name : 'distance',
          type : 'bar',
          data : [
            {
              value     : 2,
              itemStyle : {
                color : '#919191',
              },
            },
            {
              value     : 7,
              itemStyle : {
                color : '#6FB9C3',
              },
            },
            {
              value     : 16,
              itemStyle : {
                color : '#E37A3F',
              },
            },
            {
              value     : 18,
              itemStyle : {
                color : '#8F80AC',
              },
            },
            {
              value     : 23,
              itemStyle : {
                color : '#3AA203',
              },
            },
          ],
          barWidth : 18,
          label    : {
            show       : true,
            position   : 'right',
            color      : 'inherit',
            fontSize   : 14,
            fontFamily : 'Montserrat',
            fontWeight : '900',
          },
        },
      ],
    };

    option && myChart.setOption(option);
    // eslint-disable-next-line
  }, []);

  return <div
    id={id} data-testid={id}
  />;
};
